import SuperFetch from '../../superFetch.js';

class AppApi {
  /**
   *  기본적인 정보 가져오기
   */
  getAppCommonData = (data) => SuperFetch.post('/app/common', data);

  /**
   *  이미지 임시로 저장하기
   */
  addTempImg = (data) => SuperFetch.post('/app/temp/img', data);

  /**
   *  상품 상세 미리보기 데이터 요청하기
   */
  getProductPreviewData = (data) => SuperFetch.post('/app/product/detail/preview', data);

  /**
   *  태그 상세 미리보기 데이터 요청하기
   */
  getTagPreviewData = (data) => SuperFetch.post('/app/tag/detail/preview', data);

  /**
   *  주문 배송 조회 데이터 요청하기
   */
  getOrderDeliveryTrackingData = (data) => SuperFetch.post('/app/order/delivery/tracking', data);

  /**
   *  배송지 변경 이력 조회 데이터 요청하기
   */
  getOrderDeliveryModifyData = (data) => SuperFetch.post('/app/order/delivery/modify', data);

  /**
   *  반품 요청, 반품 거부, 교환 요청, 교환 거부 이미지 가져오기
   */
  getRequestRejectAttachmentData = (data) => SuperFetch.post('/app/order/attachment', data);

  /**
   *  기획전 아이템 리스트 가져오기
   */
  getEventItemList = (data) => SuperFetch.post('/app/event/item/list', data);

  /**
   *  상품 공지사항 리스트 아이템 리스트 가져오기
   */
  getNoticeProductItemList = (data) => SuperFetch.post('/app/notice/product/item/list', data);

  /**
   *  문자 발송 요청하기
   */
  sendMessageService = (data) => SuperFetch.post('/app/msgService/send', data);

  /**
   *  문자 발송 요청하기전 수신자 정보와 관리자 권한 체크하기
   */
  prepareSendMessageService = (data) => SuperFetch.post('/app/msgService/send/prepare', data);

  /**
   *  쿠폰 발급 유효성 체크 요청하기
   */
  checkValidGenerateCoupon = (data) => SuperFetch.post('/app/coupon/generate/check', data);

  /**
   *  쿠폰 발급 하기
   */
  generateCoupon = (data) => SuperFetch.post('/app/coupon/generate', data);

  /**
   *  포인트 발급 유효성 체크 요청하기
   */
  checkValidGeneratePoint = (data) => SuperFetch.post('/app/point/generate/check', data);

  /**
   *  포인트 발급 하기
   */
  generatePoint = (data) => SuperFetch.post('/app/point/generate', data);

  /**
   *  태그 유효성 검사
   */
  checkTag = (data) => SuperFetch.post('/app/tag/check', data);

  /**
   *  연관된 태그 리스트 요청하기
   */
  getRelatedTagList = (data) => SuperFetch.post('/app/tag/related', data);

  /**
   *  브랜드 상품 리스트 요청하기
   */
  getBrandProductList = (data) => SuperFetch.post('/app/brand/product/list', data);

  /**
   *  상품 2차 카테고리 리스트 가져오기
   */
  getProductSubCategoryList = (data) => SuperFetch.post('/app/category/product/sub', data);

  /**
   *  택배사 리스트 가져오기
   */
  getDeliveryAgentList = (data) => SuperFetch.post('/app/order/delivery/agent', data);

  /**
   *  아이템 검색 리스트 요청하기 - 상품 카테고리
   */
  getProductCategoryItemSearchList = (data) => SuperFetch.post('/app/itemSearch/category/product/list', data);
}

export default new AppApi();
